import { AppMountPoints } from '@apps/AppMounts'
import ActivationMount from '@sites/dealer/activation/ActivationMount'

const SiteMounts = {
  [AppMountPoints.activationMount]: ActivationMount
}

export default SiteMounts
